import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';
import { makeShirtQuestions } from './shirt-questions';

export const MERCH_POLO_TSHIRT_SUBCATEGORY_ID = 'merch-polo-tshirt';

export const MERCHANDISE_CATEGORIES: SupportCategory[] = [
  { id: 'merch-orders-polo-tshirt', label: 'Polo & T-Shirt Order', departmentId: 'Merchandise' },
  { id: 'merch-orders-welcome-bags', label: 'Staff Welcome Bags', departmentId: 'Merchandise' },
  { id: 'merch-orders-children-bags', label: 'Children Welcome Bags', departmentId: 'Merchandise' },
];

export const MERCHANDISE_SUBCATEGORIES: SupportSubcategory[] = [
  { id: MERCH_POLO_TSHIRT_SUBCATEGORY_ID, label: 'Polo & T-Shirt Order', categoryId: 'merch-orders-polo-tshirt' },
  { id: 'merch-welcome-bags', label: 'Staff Welcome Bags', categoryId: 'merch-orders-welcome-bags' },
  { id: 'merch-children-bags', label: 'Children Welcome Bags', categoryId: 'merch-orders-children-bags' },
];

export const MERCHANDISE_QUESTIONS: SupportSubcategoryQuestion[] = [
  ...makeShirtQuestions('merch', MERCH_POLO_TSHIRT_SUBCATEGORY_ID),
];
